import isStepCompleted from '../../utils/isStepCompleted';

export default function journeyStatus(journey) {
  const steps = journey.steps.filter(step => (
    step.journeyStepPivot.visible
  ));

  if (steps.every(step => isStepCompleted(step))) {
    return 'completed';
  } else if (steps.every(step => step.completion === null || step.completion.progress === null)) {
    return 'initial'
  } else {
    return 'started'
  }
}
